import { BaseTypography } from '@app/components/common/BaseTypography/BaseTypography';
import { media } from '@app/styles/themes/constants';
import styled from 'styled-components';

export const SearchResultsWrapper = styled.div`
  & > div {
    font-size: 0.875rem;
    margin-bottom: 0.5rem;

    & .ant-list-header {
      font-size: 0.75rem;
      padding-bottom: 4px;
      border-bottom: none;

      color: var(--primary-color);

      @media only screen and ${media.md} {
        font-size: 0.8125rem;
      }
    }

    & .ant-list-items {
      padding-left: 0;
    }

    & .ant-list-item {
      border-bottom: none !important;
      padding: 2px 0;
    }
  }
`;

export const CategoryHeader = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;

  & > span[role='img'],
  & svg {
    font-size: 1rem;
  }
`;

export const ResultLink = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 7px 10px;
  border-radius: 8px;
  color: var(--text-main-color);
  transition: background 0.15s ease, color 0.15s ease;

  & .result-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 7px;
    background: rgba(var(--primary-rgb-color, 0, 76, 76), 0.1);
    color: var(--primary-color);
    font-size: 0.95rem;
    flex-shrink: 0;
  }

  & .result-chevron {
    margin-left: auto;
    color: var(--text-secondary-color);
    opacity: 0;
    transition: opacity 0.15s ease;
  }

  &:hover {
    background: rgba(var(--primary-rgb-color, 0, 76, 76), 0.08);

    & .result-chevron {
      opacity: 1;
    }
  }
`;

export const Text = styled(BaseTypography.Text)`
  color: inherit;
`;
